// @ts-strict-ignore
import { FsCore } from '../../types/fs-core'

export const SET_QUERY_LOADING = 'SET_QUERY_LOADING'
export const SET_PRODUCT = 'SET_PRODUCT'
export const SET_QUERY_RESULT = 'SET_QUERY_RESULT'
export const SET_VISUAL_FILTER_BLOCK_ID = 'SET_VISUAL_FILTER_BLOCK_ID'
export const SET_PRODUCT_DATA_SET_RESULT = 'SET_PRODUCT_DATA_SET_RESULT'

export interface SetQueryResultPayload {
  queryId: string
  calculatorId?: string
  isLoading?: boolean
  isErrored?: boolean
  data: FsCore.ESQueryData
}

export const setQueryResult = (payload: SetQueryResultPayload) => ({
  type: SET_QUERY_RESULT,
  payload,
})

export interface SetQueryLoadingPayload {
  isLoading: boolean
  queryId: string
}
export const setProduct = (payload: any) => ({ type: SET_PRODUCT, payload })

export const setProductDataSetResult = (payload: any) => ({
  type: SET_PRODUCT_DATA_SET_RESULT,
  payload,
})
